import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";

import {
  Button,
  CardContent,
  CircularProgress,
  Grid,
  Tooltip,
  Typography,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LinearProgress from "@material-ui/core/LinearProgress";
import { ArrowBack, Edit, GetApp } from "@material-ui/icons";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import PropTypes from "prop-types";
import { red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
// import LinearProgressWithLabel from "./LinearProgressWithLabel"; // Adjust path if needed
import DeleteCellRenderer from "./deleteCellRenderer";
import { toUTCDate } from "../../utils/dateUtils";
import api from "../../utils/api";
import { cleanNumericValue } from "../../utils/common";

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center" flexDirection="row">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}
LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 645,
    backgroundImage:
      "linear-gradient(to right, rgba(00, 92, 73,1), rgb(10, 36, 26))",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

  paperContainer1: {
    height: 356,
    minWidth: 900,
    backgroundImage: `linear-gradient(to right bottom, rgba(255,255,255,.1), rgba(255,255,255,.1)), url(${require("../../assets/img/Back_Projects_part1.png")})`,
    backgroundPosition: "0,0",
    backgroundColor: "#174C38",
    marginBottom: 20,
  },

  GridContainer: {
    minHeight: 356,
    margin: "0 20px",
    "@media screen and (max-width:576px)": {
      margin: "0",
    },
  },
  textSecondary: {
    color: "#ffffff",
  },
  paper: {
    position: "absolute",

    backgroundColor: "var(--neutralOffWhite)",
    border: "2px solid #000",
    boxShadow: "var(--neutralGray)",
    padding: "0px 25px 15px 30px",
  },
  smallWidth: {
    width: 400,
  },
  mediumWidth: {
    width: 900,
  },
  largeWidth: {
    width: "90%",
    maxWidth: 1200,
  },
  textdata: {
    color: "#1164B4",
    fontSize: "14px",
    fontWeight: "bold",
  },
  height: {
    height: 600,
    overflow: "auto",
  },
  progressWidth: {
    width: 300,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "scroll",
  },
  paper1: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[9],
    padding: theme.spacing(2, 4, 3),
  },
  btn: {
    border: "1px solid #fff",
    borderRadius: 0,
    padding: "5px 8px",
    // marginBottom: "65px",
    textAlign: "center",
    cursor: "pointer",
    color: "#fff"
  },
  media: {
    height: 50,
    paddingTop: "56.25%", // 16:9
  },
  avatar: {
    backgroundColor: red[500],
  },
  whiteInputLabel: {
    color: '#fff',
    textDecoration: 'none !important', // removes strikethrough
  },
  findReplaceContainer: {
    color: '#fff',
    display: "flex",
    alignItems: "center",
    gap: "12px", // spacing between Find, Replace, and Button
    margin: "16px 0",
    flexWrap: "wrap", // wrap on small screens
    '@media screen and (max-width: 576px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '8px',
    },
  },
  rowError: {
    backgroundColor: "#ffe5e5"
  }

  /*   correctRow: {
      background: "white",
    },
    incorrectRow: {
      background: red[100],
    }, */
}));

const styles = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "colored",
}
const ImportShipmentLCLCNNPage = ({

}) => {
  const classes = useStyles();
  const gridRef = useRef();
  let gridApi = React.useRef(null);
  const APIBASE_URL = process.env.REACT_APP_APIBASE_URL;

  const MemberCode = useSelector((state) => state.memberreducer.MemberCode);
  const [noncarbonNutralisedShipemnts, setNonCarbonNutralisedShipemnts] =
    useState([]);
  const [addShipmentSuccess, setAddShipmentSuccess] = useState(false);
  const [importSuccess, setImportSuccess] = useState(false);
  const [calcSuccess, setCalcSuccess] = useState(true);
  const [isLoadingCircle, setIsLoadingCircle] = useState(false);
  const [isLoadingBar, setIsLoadingBar] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isValidate, setValidate] = useState(true);

  const [selectedRows, setSelectedRows] = useState([]);
  const [saveShipments, setSaveShipments] = useState([]);

  const [transshipments, setTransShipments] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [gridColumns, setGridColumns] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [updatedGridData, setUpdatedGridData] = useState([]);
  const [calcLoading, setCalcLoading] = useState(false);

  const [allGridData, setAllGridData] = useState([]);

  const [selectedColumn, setSelectedColumn] = useState("");
  const [findValue, setFindValue] = useState("");
  const [replaceValue, setReplaceValue] = useState("");

  const [nor40, setNor40] = useState(false);

  const [shipments, setShipments] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(1);
  const [filterOptions, setFilterOptions] = useState([{ field: 1, value: 'All' }, { field: 2, value: 'Valid' }, { field: 3, value: 'Invalid' }]);

  const [progress, setProgress] = useState(0);
  const [circleProgress, setCircleProgress] = useState(0);
const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  // 🚨 NEW HANDLERS FOR MODAL
  const handleOpenModal = (message) => {
    setModalMessage(message);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalMessage("");
  };
  const gridApiRef = useRef(null); // to store the API
  const [availableAllOriginDestinations, setAvailableAllOriginDestinations] =
    useState([{}]);
  const [availableCarriers, setavailableCarriers] = useState([{}]);
  const [onlyCrrName, setOnlyCrrName] = useState([{}]);
  const [projChekbox, setProjChekbox] = useState([]);
  const [availableContSize] = useState([
    { Size: "20GP" },
    { Size: "40GP" },
    { Size: "40HC" },
    { Size: "45G1" },
    { Size: "22R1" },
    { Size: "40REHC" },
    { Size: "53GP" },
  ]);
  const [availableBlType] = useState([
    { type: "Door-CY" },
    { type: "Door-Door" },
    { type: "CY-CY" },
    { type: "CY-Door" },
    { type: "CY-CY/Ramp" },
    { type: "Door-CY/Ramp" },
  ]);
  const [availableTRansMode] = useState([
    { mode: "road", view: "Truck" }, // Truck
    { mode: "rail", view: "Rail" }, // Rail
    { mode: "inlnd-water", view: "Barge" }, // Barge
    { mode: "sea", view: "Sea" }, // Sea
  ]);
  const [state, setState] = useState({
    selectedCarrier: undefined,
    selectedOrigin: undefined,
    selectedDestination: undefined,
    selectedLoadPort: undefined,
    selectedDiscPort: undefined,
    selectedTransShpPort: undefined,
    selectedCyRamp: undefined,
    selectedPlaceofOrigin: undefined,
    originValue: "",
    loadPortValue: "",
    discPortValue: "",
    transShpPortValue: "",
    cyRampValue: "",
    destinationValue: "",
    originPlaceValue: "",
    carrierValue: "",
    dischargePlaceValue: "",
    fileName: "Choose Excel File to Import Shipments",
    selectedTrnsModeORGN: availableTRansMode[3],
    selectedTrnsModeLOAD: availableTRansMode[3],
    selectedTrnsModeDISC: availableTRansMode[1],
    selectedTrnsModeCYRAMP: availableTRansMode[0],
    selectedTrnsModeTRANS: "Sea",
    availableDestinations: [{}],
    availablePortofDischarge: [{}],
    availableCarriers: [{}],
    slectedBLType: availableBlType[2],
    containerNo: "",
    containerSize: availableContSize[2],
    vessel: "",
    voyage: "",
    transMode: "",
    transShipvessel: "",
    totalCO2Emision: 0,
    isChecked: false,
    addShipmentAction: "ADD",
    shipmentIdToEdit: "",
    comment1: "",
    comment2: "",
    OriginAddress: "",
    OriginZIPCode: "",
    DestinationAddress: "",
    DestinationZIPCode: "",
  });
  const [selectedPOLDate, setSelectedPOLDate] = React.useState(new Date());

  const navigateBack = () => {
    window.history.back();
  };

  const getShipmentList = () => {
    api
      .get(
        `${APIBASE_URL}/GreenShipmentLoadType?MemberCode=${MemberCode}&ShipmentType=N&LoadType=LCL`
      )
      .then((res) => {
        console.log(res.data);
        const carriers = res.data;
        const nwCrr = carriers.map((el) => {
          return {
            ...el,
            id: el.GR_SH_ID,
          };
        });
        const zeroEmsn = carriers.filter((el) => {
          return el.CO2Emission_in_grams === 0;
        });
        console.log(zeroEmsn);
        handleZeroEmsnVal(zeroEmsn);
        setNonCarbonNutralisedShipemnts(nwCrr);
        console.log(nwCrr);
      })
      .catch(() => {
        setNonCarbonNutralisedShipemnts([]);
      });
  };

  const gridReady = (params) => {
    gridApi.current = params.api;

    gridApi.current.sizeColumnsToFit();
    gridApiRef.current = params.api;
    params.api.sizeColumnsToFit(); // optional
  };
  const onSelectionChanged = useCallback(() => {
    var selectedRows = gridRef.current.api.getSelectedRows();
    console.log(selectedRows);
    setSelectedRows(selectedRows);
    var totalCO2Emsn = 0;
    selectedRows.forEach(function (selectedRow, index) {
      totalCO2Emsn += selectedRow.CO2Emission_in_grams;
    });
    console.log(totalCO2Emsn);

    setState((prev) => ({ ...prev, totalCO2Emision: totalCO2Emsn }));
  }, []);

  const handleZeroEmsnVal = (val) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    };
    val.forEach((res) => {
      api
        .post(
          `${APIBASE_URL}/GreenShipments?EditFlag=1&vType=C`,
          res,
          requestOptions
        )
        .then((resp) => {
          console.log(resp);
          if (resp.status === 200) {
            console.log("Shipment edited successfully!");

          }
        });
    });
  };
  const handleImport = ($event) => {
    setIsLoadingCircle(true);
    const files = $event.target.files;
    debugger
    setState({ ...state, fileName: files[0].name });
    setImportSuccess(false);

    function excelDateToMMDDYYYY(excelDate) {
      // Function to convert Excel date number to "mm/dd/yyyy" format
      const date = new Date(Date.UTC(1899, 11, 30));
      date.setDate(date.getDate() + excelDate);
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    }

    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const Key = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const normalizeHeader = (header) => header.replace(/[.]/g, "").trim();

        // Ensure gridColData is valid and correctly structured
        const headers = Key[0].map((r) => r.trim());
        const normalizedHeaders = headers.map(normalizeHeader);

        // Rebuild column definitions
        let gridColData = headers.map((r) => {
          const normalizedHeader = normalizeHeader(r);
          return {
            field: normalizedHeader,
            headerName: r,
            editable: true
          };
        });

        const gridData = Key.slice(1).map((row) => {
          const rowData = {};
          gridColData.forEach((col, i) => {
            const originalIndex = normalizedHeaders.findIndex(
              (h) => h.toLowerCase() === col.field.toLowerCase()
            );
            let value = row[originalIndex];

            // Check if the field is "POLDate" and it's a number
            if (col.field === "POL Date" && typeof value === "number") {
              value = excelDateToMMDDYYYY(value);
            }
            value = cleanNumericValue(value);

            if (value === null || value === undefined || value === "") {
              value = null;
            }
            rowData[col.field] = value;
          });
          return rowData;
        });
        setGridColumns(gridColData);
        setGridData(gridData);
        setAllGridData(gridData);

        Key.forEach((row) => {
          if (typeof row[20] === "number") {
            // Assuming date is in the third column
            row[20] = excelDateToMMDDYYYY(row[20]);
          }
        });
        const bodyData = JSON.stringify({ Key });
        const PostOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        };
      };
      reader.readAsArrayBuffer(file);
    }
    setValidate(true);
    setCalcSuccess(true);
  };
  const handleValidate = () => {
    setLoading(true);
    const gridColumnsData = gridColumns.filter((i) => i.field !== 'FailReason');
    const failedRecords = gridData.filter(i => i.FailReason);
    let validRecords = [];
    let inputGridData
    if (isValidate) {
      inputGridData = gridData.map(item => {
        const newItem = { ...item };
        delete newItem.FailReason;
        return newItem;
      })
    } else {
      validRecords = gridData.filter(i => !i.FailReason);
      inputGridData = failedRecords.map(item => {
        const newItem = { ...item };
        delete newItem.FailReason;
        return newItem;
      })
    }
    setGridColumns(gridColumnsData);
    setGridData(inputGridData.length > 0 ? inputGridData : validRecords);

    if (inputGridData.length > 0) {
      const input = [gridColumnsData, inputGridData]
      const output = transformGrid(input);
      const bodyData = JSON.stringify({ Key: output });
      console.log(bodyData);
      const PostOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      };
      api
        .post(`${APIBASE_URL}/GreenShipmentsTemp?Temp=2&membercode=${MemberCode}`, bodyData, PostOptions)
        .then((respEx) => {
          if (respEx.status === 200) {
            const validatedShpmts = respEx.data;
            console.log(shipments)

            const input3 = [
              ...validatedShpmts,
              ...shipments?.filter(
                (item1) => !validatedShpmts.some(item2 => item2.ContainerNo === item1.ContainerNo)
              )
            ];
            const updatedRecords = input3.map((el, i) => {
              return {
                ...el,
                id: i + 1,
              };
            });
            setShipments(updatedRecords);

            const shipmentMap = new Map();
            updatedRecords.forEach(shipment => {
              shipmentMap.set(shipment.ContainerNo, shipment.FailReason);
            });

            let isFailedReason = false;

            // Add FailReason to each item in gridData
            const updatedValidatedData = inputGridData.map(item => {
              const failReason = shipmentMap.get(item.ContainerNo);
              if (!isFailedReason) {
                isFailedReason = failReason ? true : false
              }
              return {
                ...(failReason ? { FailReason: failReason } : {}),
                ...item
              };
            });
            const finalData = [...validRecords, ...updatedValidatedData];
            if (isFailedReason) {
              const updatedColumns = [
                {
                  field: "FailReason",
                  headerName: "Fail Reason",
                  // cellRenderer: FailReasonTooltipRenderer, 
                  cellRenderer: 'failReasonRenderer', // 🚨 Use the registered component name
                  cellRendererParams: frameworkComponentParams,
                  minWidth: 200, // Give it more space
                  tooltipField: "FailReason",
                },
                ...gridColumns.filter(col => col.field !== "FailReason"), // Avoid duplicates
              ];
              setGridColumns(updatedColumns);
            } else {
              toast.success('Validation passed. Please proceed with emission calculation...', styles);
              setImportSuccess(true)
            }
            const sortedCo2eData = [...finalData].sort((a, b) => {
              if (a.FailReason && !b.FailReason) return -1;
              if (!a.FailReason && b.FailReason) return 1;
              return 0;
            });
            setGridData(sortedCo2eData);
            setAllGridData(sortedCo2eData);
            setUpdatedGridData(sortedCo2eData.map(item => {
              const newItem = { ...item };
              delete newItem.FailReason;
              return newItem;
            }));
            setCircleProgress(0);
            setLoading(false);
          } else {
            toast.error("Wrong excel template choosen! Please choose the excel file with correct template!", styles);
          }
        });
    }
    setLoading(false);
    setValidate(false)
  };
  const handleDeleteSelected = () => {
    if (selectedRows.length === 0) return;

    const selectedContainerNos = selectedRows.map(row => row.ContainerNo);
    const newGridData = gridData.filter(row => !selectedContainerNos.includes(row.ContainerNo));
    const newAllGridData = allGridData.filter(row => !selectedContainerNos.includes(row.ContainerNo));

    setGridData(newGridData);
    const filteredShpmts = saveShipments.filter(item1 =>
      newGridData.some(item2 => item2.ContainerNo === item1.ContainerNo)
    );
    setSaveShipments(filteredShpmts)
    setAllGridData(newAllGridData);

    const allowedContainerNos = new Set(newAllGridData.map(item => item.ContainerNo));
    const filteredShipments = shipments.filter(shipment =>
      allowedContainerNos.has(shipment.ContainerNo)
    );
    setShipments(filteredShipments);

    setUpdatedGridData(newGridData.map(item => {
      const newItem = { ...item };
      delete newItem.FailReason;
      return newItem;
    }));
    setSelectedRows([]);
    const shipmentMap = new Map();
    newGridData.forEach(shipment => {
      shipmentMap.set(shipment.ContainerNo, shipment.FailReason);
    });

    let isFailedReason = false;
    newGridData.map(item => {
      const failReason = shipmentMap.get(item.ContainerNo);
      if (!isFailedReason) {
        isFailedReason = failReason ? true : false
      }
    });

    if (!isFailedReason) {
      setImportSuccess(true)
    }
  };
  const FailReasonClickableRenderer = (props) => {
    const classes = useStyles(); // Use the styles hook if you have a class for rowError or similar
    const failReason = props.value;
    const { onOpenModal } = props; // Function passed down from the parent
    if (!failReason) {
        return null;
    }
    return (
        <span 
            onClick={() => onOpenModal(failReason)}
            style={{ 
                cursor: 'pointer', 
                color: '#000'
            }}
        >
            {failReason.length > 30 ? `${failReason.substring(0, 30)}... (Click to view)` : failReason}
        </span>
    );
};
const frameworkComponents = {
    failReasonRenderer: FailReasonClickableRenderer,
  };
    const frameworkComponentParams = {
    onOpenModal: handleOpenModal,
  };
  const handleDownloadExcel = () => {
    if (!gridData || gridData.length === 0) {
      toast.info("No data available to download.", styles);
      return;
    }

    // 1. Get the current column headers in the correct order
    const headers = gridColumns.map(col => col.headerName);

    // 2. Map gridData (array of objects) to an array of arrays (rows)
    const dataForSheet = gridData.map(row => {
      return gridColumns.map(col => {
        // Retrieve the value using the field name
        let value = row[col.field];

        // Handle null/undefined values for cleaner Excel output
        if (value === null || value === undefined) {
          value = "";
        }
        return value;
      });
    });

    // 3. Combine headers and data
    const finalData = [headers, ...dataForSheet];

    // 4. Create a worksheet and a workbook
    const ws = XLSX.utils.aoa_to_sheet(finalData); // aoa_to_sheet converts Array of Arrays (AoA)
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ShipmentData");

    // 5. Write the workbook to a file and trigger download
    const fileName = `Shipment_Import_Data_${new Date().toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(wb, fileName);

    toast.success("Excel file successfully downloaded!", styles);
  };
  const handleSudoImport = () => {
    setImportSuccess(false);
    setCalcLoading(true)
    const CopyShipments = window.structuredClone(shipments);
    // Exclude rows where status is 'Exitsting'
    const filteredShipments = CopyShipments.filter((shipment) => {
      return shipment.CO2EmissionFlag !== "Y";
    });

    if (filteredShipments.length > 0) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      };
      api.post(`${APIBASE_URL}/GetCO2EData?vType=C`, filteredShipments, requestOptions)
        .then((res) => {
          setTimeout(() => {
            setCalcLoading(false);
          }, 1000);
          setCalcSuccess(false)
          const merged = res.data.map(container => {
            const match = gridData.find(item => item.ContainerNo === container.ContainerNo);
            return {
              ...container,
              POLDate: match ? toUTCDate(match["POL Date"]) : null
            };
          });
          setSaveShipments(merged)
          const calcMap = new Map();
          const errorMap = new Map();
          res.data.forEach(shipment => {
            calcMap.set(shipment.ContainerNo, shipment.CO2Emission_in_grams);
            errorMap.set(shipment.ContainerNo, shipment.FailReason);
          });

          let isCo2Emission = false;

          const updatedCo2eData = gridData.map(item => {
            const co2e = calcMap.get(item.ContainerNo);
            const failReason = errorMap.get(item.ContainerNo);
            if (!isCo2Emission) {
              isCo2Emission = co2e ? true : false
            }
            return {
              ...(co2e ? { CO2Emission_in_grams: co2e } : { FailReason: failReason || 'co2e is not exist' }),
              ...item
            };
          });
          const hasCalcFailReasons = updatedCo2eData.some(item => item.FailReason);
          if (isCo2Emission) {
            const updatedColumns = [
               ...(hasCalcFailReasons ? [{ 
                field: "FailReason",
                headerName: "Fail Reason",
                cellRenderer: 'failReasonRenderer', // 🚨 Use the registered component name
                cellRendererParams: frameworkComponentParams,
                minWidth: 200,
                tooltipField: "FailReason"
              }] : []),
              ...gridColumns.filter(col => !["co2e", "FailReason"].includes(col.field)),
              {
                field: "CO2Emission_in_grams",
                headerName: "CO2 Emission in grams"
              }
            ];
            toast.success(
              "Calculated emission added to list. Proceed with save shipment by clicking on submit",
              styles
            );
            setGridColumns(updatedColumns);
          } else {
            const updatedColumns = [
              {
                field: "FailReason",
                headerName: "Fail Reason",
                cellRenderer: 'failReasonRenderer', // 🚨 Use the registered component name
                  cellRendererParams: frameworkComponentParams,
                minWidth: 200,
                tooltipField: "FailReason"
              },
              ...gridColumns.filter(col => !["co2e", "FailReason"].includes(col.field))
            ];
            setGridColumns(updatedColumns);
            setImportSuccess(true);
          }

          const sortedCo2eData = [...updatedCo2eData].sort((a, b) => {
            if (a.FailReason && !b.FailReason) return -1;
            if (!a.FailReason && b.FailReason) return 1;
            return 0;
          });
          setGridData(sortedCo2eData);
          setAllGridData(sortedCo2eData);
        })
        .catch((err) => {
          setImportSuccess(true);
          setCalcLoading(false)
        })

      setShipments([]);
      setState({
        ...state,
        fileName: "Choose Excel File to Import Shipments",
      });

      setProgress(0);
    } else {
      toast.error("No Valid Shipment to be added. Please import correct data!", styles);
      setShipments([]);
      setState({ ...state, fileName: "Choose Excel File to Import Shipments" });
      setIsLoadingBar(false);
      setCalcLoading(false);
    }
  };
  const handleSaveShipment = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    };
    api
      .post(`${APIBASE_URL}/BulkInsertShipmentFromJSON?MemberCode=${MemberCode}`, saveShipments, requestOptions)
      .then((resp) => {
        console.log(resp);
        if (resp.status === 200) {
          toast.success("Shipment imported successfully!", styles);
          setCalcSuccess(true)
          setImportSuccess(false)
        }
      });
  };
  const handleFilter = (e) => {
    setSelectedFilter(e.target.value)
    if (e.target.value == 1) {
      setGridData(allGridData)
    }
    if (e.target.value == 2) {
      setGridData(allGridData.filter((i) => i.FailReason))
    }
    if (e.target.value == 3) {
      setGridData(allGridData.filter((i) => !i.FailReason))
    }
  };
  function transformGrid(input) {
    const columns = input[0];
    const rows = input[1];

    // Extract header names in the given order
    const headers = columns.map(col => col.headerName);

    // Transform each row object into an array following column order
    const dataRows = rows.map(row =>
      columns.map(col => row[col.field] ?? null)
    );

    // Combine headers and dataRows
    return [headers, ...dataRows];
  }
  const getRowClassImport = (params) => {
    if (params.data.FailReason) {
      return "incorrectRow"; // Red for failed records
    } else if (params.data.CO2EmissionFlag === "Y") {
      return "incorrectRow"; // Optional: use this for CO2 flags if needed
    } else {
      return "correctRow"; // Optional fallback
    }
  };
  const onCellValueChanged = (params) => {
    console.log("Cell changed", params);
    // You can update your data here or make an API call
    const data = allGridData.map((i) => params.data.ContainerNo == i.ContainerNo ? params.data : i)
    console.log('dataaaa', data);
    setAllGridData(data)

    if (!selectedFilter || selectedFilter == 1) {
      setGridData(allGridData)
    }
    if (selectedFilter == 2) {
      setGridData(allGridData.filter((i) => i.FailReason))
    }
    if (selectedFilter == 3) {
      setGridData(allGridData.filter((i) => !i.FailReason))
    }
  };

  const handleFindReplace = () => {
    if (!selectedColumn || !findValue) return;
    const updatedData = gridData.map((row) => {
      if (row[selectedColumn] === findValue) {
        return { ...row, [selectedColumn]: replaceValue };
      }
      return row;
    });

    setGridData(updatedData);
  };
  useEffect(() => {
    if (gridApiRef.current) {
      if (isLoading) {
        gridApiRef.current.showLoadingOverlay();
      } else {
        gridApiRef.current.hideOverlay();
      }
    }
  }, [isLoading]);
  useEffect(() => {
    // getShipmentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [MemberCode, addShipmentSuccess]);

  return (
    <>
      <CardContent>
        <Grid container spacing={3} style={{ padding: '0', display: "flex", alignItems: "center" }}>
          <Grid item sm={6} md={6} lg={6} sx={12} style={{ padding: '0 12px' }}>
            <Typography variant="h5" style={{ display: "inline-block", color: "white", paddingLeft: '15px' }}>
              Import Shipments - LCL
            </Typography>
          </Grid>
          <Grid
            item
            sm={12}
            md={6}
            lg={6}
            sx={12}
            style={{ textAlign: "end", padding: '0 12px' }}
          >
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleSudoImport}
              style={{
                width: 220,
                textTransform: "capitalize",
                color: importSuccess ? 'white' : 'gray',
                marginRight: '5px'
              }}
              disabled={!importSuccess || calcLoading}
            >
              {calcLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                'Calculate Emission'
              )}
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleSaveShipment}
              style={{ width: 120, textTransform: "capitalize", color: calcSuccess ? 'gray' : 'white', marginRight: '5px' }}
              disabled={calcSuccess}
            >
              Submit
            </Button>
            {isLoadingBar && (
              <LinearProgressWithLabel
                value={progress}
                className={classes.progressWidth}
              />
            )}
            <Tooltip title="Download Data to Excel">
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={handleDownloadExcel}
                style={{
                  width: 50, // Smaller width for icon button
                  textTransform: "capitalize",
                  color: gridData.length > 0 ? 'white' : 'gray',
                  marginRight: '5px',
                  minWidth: 'unset' // Allows for smaller button size
                }}
                disabled={gridData.length === 0}
              >
                <GetApp /> {/* The download icon */}
              </Button>
            </Tooltip>
            <Tooltip title="Back">
              <Button style={{ marginRight: '17px' }}
                size="small"
                variant="contained"
                color="primary"
                onClick={navigateBack}
              >
                <ArrowBack />
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
        <CardContent style={{ paddingTop: '0', paddingBottom: '0' }}>
          <div style={{ height: 375, width: "100%" }}>
            <div className="custom-file">
              <label htmlFor="fileInput" className={classes.btn}>
                {state.fileName}
              </label>
              <input
                type="file"
                name="file"
                className="custom-file-input"
                id="fileInput"
                required
                style={{ visibility: "hidden", paddingBottom: 15, display: 'none' }}
                onChange={handleImport}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />


              <Box className={classes.findReplaceContainer}>
                <FormControl size="small" style={{ minWidth: 200, color: "#fff" }}>
                  <InputLabel style={{ color: "#fff" }}>Select Column</InputLabel>
                  <Select
                    value={selectedColumn}
                    style={{ color: "#fff", borderBottom: "1px solid #fff" }}
                    label="Select Column"
                    onChange={(e) => setSelectedColumn(e.target.value)}
                  >
                    {gridColumns.map((col) => (
                      <MenuItem key={col.field} value={col.field}>
                        {col.headerName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {selectedColumn && (
                  <div>
                    <TextField label="Find" variant="standard" size="small"
                      value={findValue} style={{ borderBottom: "1px solid #fff", marginRight: "15px", textDecoration: 'none' }}
                      onChange={(e) => setFindValue(e.target.value)}
                      InputLabelProps={{ style: { color: '#fff', textDecoration: 'none' } }}
                      InputProps={{
                        style: { color: '#fff', textDecoration: 'none' },
                        classes: {
                          notchedOutline: classes.whiteBorder,
                        },
                      }}
                    />
                    <TextField label="Replace" variant="standard" size="small"
                      value={replaceValue} style={{ borderBottom: "1px solid #fff", marginRight: "15px" }}
                      onChange={(e) => setReplaceValue(e.target.value)}
                      InputLabelProps={{ style: { color: '#fff' } }}
                      InputProps={{
                        style: { color: '#fff' },
                        classes: {
                          notchedOutline: classes.whiteBorder,
                        },
                      }}
                    />
                    <Button variant="contained" style={{ marginTop: "9px", textTransform: "capitalize" }}
                      color="secondary"
                      onClick={handleFindReplace}
                    >Replace</Button>
                    <Button variant="contained" style={{ marginTop: "9px", marginLeft: "5px", textTransform: "capitalize" }}
                      color="secondary"
                      onClick={(e) => setSelectedColumn("")}
                    >Reset</Button>
                  </div>

                )}
                <FormControl size="small" style={{ minWidth: 200, color: "#fff" }}>
                  <InputLabel style={{ color: "#fff" }}>Select Filter</InputLabel>
                  <Select
                    value={selectedFilter}
                    style={{ color: "#fff", borderBottom: "1px solid #fff" }}
                    label="Select Filter"
                    onChange={(e) => handleFilter(e)}
                  >
                    {filterOptions.map((col) => (
                      <MenuItem key={col.field} value={col.field}>
                        {col.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ width: 100, textTransform: "capitalize", paddingTop: '7px', paddingBottom: '7px', marginTop: '7px' }}
                  onClick={handleValidate}
                >Validate
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ width: 150, textTransform: "capitalize", paddingTop: '7px', paddingBottom: '7px', marginTop: '7px' }}
                  onClick={handleDeleteSelected}
                  disabled={selectedRows.length === 0}
                >
                  Delete
                </Button>
              </Box>
            </div>
            <div
              style={{
                height: 'calc(100vh - 325px)',
                maxWidth: "100%",
                overflowX: "auto",
              }}
              className="ag-theme-alpine"
            >
              <AgGridReact
                ref={gridRef}
                columnDefs={gridColumns}
                rowData={gridData}
                rowSelection="multiple"
                onSelectionChanged={onSelectionChanged}
                onCellValueChanged={onCellValueChanged}
                defaultColDef={{
                  resizable: true,
                  sortable: true,
                  filter: "agTextColumnFilter",
                }}
                pagination
                paginationPageSize={50}
                onGridReady={gridReady}
                getRowClass={getRowClassImport}
                frameworkComponents={frameworkComponents}
              />
            </div>
          </div>
        </CardContent>
        <CardContent
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 20,
            // paddingTop: '90px'
            position: "relative",
            bottom: "-190px",
          }}
        >

        </CardContent>
      </CardContent>
      <ToastContainer />
      <Dialog 
        open={isModalOpen} 
        onClose={handleCloseModal} 
        aria-labelledby="error-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="error-dialog-title" style={{ color: '#d32f2f' }}>
          Validation/Calculation Error
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {modalMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary" variant="contained" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ImportShipmentLCLCNNPage;
